import { useCallback } from 'react';
import type { FC } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import PublicIcon from '@/material-icons/400-24px/public.svg?react';
import PublicOffIcon from '@/material-icons/400-24px/public_off.svg?react';
import { changeComposeLocalOnly } from '@/mastodon/actions/compose';
import { IconButton } from '@/mastodon/components/icon_button';
import { useAppDispatch, useAppSelector } from '@/mastodon/store';

// Local-only posts (bolha): the post stays on this server and is never federated.
const messages = defineMessages({
  federated: {
    id: 'compose_form.local_only.off',
    defaultMessage: 'Federated: reaches other servers. Click to keep it local',
  },
  localOnly: {
    id: 'compose_form.local_only.on',
    defaultMessage: 'Local-only: stays on this server. Click to federate',
  },
  locked: {
    id: 'compose_form.local_only.locked',
    defaultMessage: 'Local-only: replies to a local-only post stay local',
  },
});

const iconStyle = {
  lineHeight: '27px',
};

export const LocalOnlyButton: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const localOnly = useAppSelector(
    (state) => state.compose.get('local_only') as boolean,
  );
  const locked = useAppSelector(
    (state) => state.compose.get('local_only_locked') as boolean,
  );

  const handleClick = useCallback(() => {
    dispatch(changeComposeLocalOnly(!localOnly));
  }, [dispatch, localOnly]);

  let title = intl.formatMessage(messages.federated);
  if (locked) {
    title = intl.formatMessage(messages.locked);
  } else if (localOnly) {
    title = intl.formatMessage(messages.localOnly);
  }

  return (
    <div className='compose-form__poll-button'>
      <IconButton
        icon={localOnly ? 'public-off' : 'public'}
        iconComponent={localOnly ? PublicOffIcon : PublicIcon}
        title={title}
        disabled={disabled ?? locked}
        onClick={handleClick}
        active={localOnly}
        className={`compose-form__poll-button-icon ${localOnly ? 'active' : ''}`}
        inverted
        style={iconStyle}
      />
    </div>
  );
};
